import { Search } from "lucide-react";

export function SearchBox({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  return (
    <label className="search-box">
      <Search size={20} aria-hidden="true" />
      <span className="sr-only">Search calculators</span>
      <input
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder="Search 2000 calculators: mortgage, BMI, concrete, percentage..."
      />
    </label>
  );
}
